import {
  DETAIL_ORDER_VINCULATION_LIST,
  DETAIL_ORDER_VINCULATION_LIST_ERROR,
} from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const orderVinculationDetailListAction = (transactions_id) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(`/api/reports/linked_up/${transactions_id}`);
    const { data, status } = response || {};

    dispatch({
      type: DETAIL_ORDER_VINCULATION_LIST,
      response: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: DETAIL_ORDER_VINCULATION_LIST_ERROR,
      response: e || {},
    });
  }
};
